/**
 * Asynchronously loads the component for PiecripSignUpPage
 */

import { lazyLoad } from '@utils/loadable';

export const PiecripSignUpPage = lazyLoad(
  () => import('./index'),
  (module) => module.PiecripSignUpPage,
);
